import React from "react";
import { fromJS } from "immutable";
import { SelectOption } from "@showitinc/showit-wc";

import Input from "../../../base/Input";
import AppConstants from "../../../../constants/AppConstants";
import { INPUT_TYPE_NUMBER } from "../../../../constants/ElementConstants";
import {
  GALLERY_AUTO_ADVANCE_TIME,
  GALLERY_TRANSITION,
  GALLERY_TRANSITION_DURATION,
  GRAPHIC_STYLE_TYPE,
} from "../../../../constants/MergeConstants";
import { gatherProps } from "../../../../utils/Merge/MergeUtils.mjs";
import { elementSyncUtils } from "../../../../utils/SyncUtils";
import { initFormatter } from "../../../../utils/PropertyFormatters";
import SplitMergeWrapper from "../../../base/SplitMergeWrapper";
import { SELECT } from "../../../../constants/InputConstants.mjs";
import { prepareInputUtils } from "../../../../utils/InputUtils";

const {
  GRAPHIC_SCALE_CONTAIN,
  GRAPHIC_SCALE_FILL,
  DEFAULT_AUTO_ADVANCE_TIME,
  DEFAULT_GALLERY_TRANSITION,
  GALLERY_TRANSITION_FADE,
  GALLERY_TRANSITION_NONE,
  GALLERY_TRANSITION_SLIDE,
  DEFAULT_GALLERY_TRANSITION_TIME,
} = AppConstants;

const gatherableProps = [
  GALLERY_AUTO_ADVANCE_TIME,
  GALLERY_TRANSITION,
  GALLERY_TRANSITION_DURATION,
  GRAPHIC_STYLE_TYPE,
];

const defaults = fromJS({
  gs: {
    t: GRAPHIC_SCALE_FILL,
  },
  gallery: {
    aa: DEFAULT_AUTO_ADVANCE_TIME,
    tran: DEFAULT_GALLERY_TRANSITION,
    tranTime: DEFAULT_GALLERY_TRANSITION_TIME,
  },
});

const ElementPropertiesGallerySimple = ({
  disabled,
  element,
  layout,
  onPropUpdate,
  preparedElement,
}) => {
  const _onPropChange = (propInfo) => onPropUpdate && onPropUpdate(propInfo);

  const { isSynced, toggleSyncedProp, getPropName } = elementSyncUtils(
    element,
    _onPropChange,
    layout
  );
  const elemProps = defaults.mergeDeep(gatherProps(preparedElement, layout, gatherableProps));

  const { onChange } = initFormatter(onPropUpdate, getPropName);

  const separatePath = (path) => path.split(".");
  const getValue = (path) => elemProps.getIn(separatePath(path));
  const prepChange = (path) => [path, getValue(path)];

  const { canMerge, prepareValue, isSyncMixed } = prepareInputUtils(
    layout,
    preparedElement,
    elemProps
  );

  return (
    <>
      <SplitMergeWrapper
        layout={layout}
        mixed={isSyncMixed(GRAPHIC_STYLE_TYPE)}
        sync={isSynced(GRAPHIC_STYLE_TYPE)}
        toggleSync={() => toggleSyncedProp(GRAPHIC_STYLE_TYPE)}
      >
        <Input
          context={canMerge(GRAPHIC_STYLE_TYPE)}
          disabled={disabled}
          inputType={SELECT}
          label="Size"
          onSISelect={onChange(...prepChange(GRAPHIC_STYLE_TYPE))}
          shift="left"
          value={prepareValue(GRAPHIC_STYLE_TYPE)}
        >
          <SelectOption value={GRAPHIC_SCALE_FILL}>Fill</SelectOption>
          <SelectOption value={GRAPHIC_SCALE_CONTAIN}>Contain</SelectOption>
        </Input>
      </SplitMergeWrapper>
      <SplitMergeWrapper
        layout={layout}
        mixed={isSyncMixed(GALLERY_AUTO_ADVANCE_TIME)}
        sync={isSynced(GALLERY_AUTO_ADVANCE_TIME)}
        toggleSync={() => toggleSyncedProp(GALLERY_AUTO_ADVANCE_TIME)}
      >
        <Input
          context={canMerge(GALLERY_AUTO_ADVANCE_TIME)}
          disabled={disabled}
          min="0"
          label="Auto Advance"
          onSIBeforeChange={onChange(...prepChange(GALLERY_AUTO_ADVANCE_TIME))}
          onSIInput={onChange(...prepChange(GALLERY_AUTO_ADVANCE_TIME), false)}
          step="0.25"
          type={INPUT_TYPE_NUMBER}
          units="sec"
          value={prepareValue(GALLERY_AUTO_ADVANCE_TIME)}
        />
      </SplitMergeWrapper>
      <SplitMergeWrapper
        layout={layout}
        mixed={isSyncMixed(GALLERY_TRANSITION)}
        sync={isSynced(GALLERY_TRANSITION)}
        toggleSync={() => toggleSyncedProp(GALLERY_TRANSITION)}
      >
        <Input
          context={canMerge(GALLERY_TRANSITION)}
          disabled={disabled}
          inputType={SELECT}
          label="Transition"
          onSISelect={onChange(...prepChange(GALLERY_TRANSITION))}
          shift="left"
          value={prepareValue(GALLERY_TRANSITION)}
        >
          <SelectOption value={GALLERY_TRANSITION_FADE}>Fade</SelectOption>
          <SelectOption value={GALLERY_TRANSITION_SLIDE}>Slide</SelectOption>
          <SelectOption value={GALLERY_TRANSITION_NONE}>None</SelectOption>
        </Input>
      </SplitMergeWrapper>
      <SplitMergeWrapper
        layout={layout}
        mixed={isSyncMixed(GALLERY_TRANSITION_DURATION)}
        sync={isSynced(GALLERY_TRANSITION_DURATION)}
        toggleSync={() => toggleSyncedProp(GALLERY_TRANSITION_DURATION)}
      >
        <Input
          context={canMerge(GALLERY_TRANSITION_DURATION)}
          disabled={disabled}
          min="0"
          label="Transition Time"
          onSIBeforeChange={onChange(...prepChange(GALLERY_TRANSITION_DURATION))}
          onSIInput={onChange(...prepChange(GALLERY_TRANSITION_DURATION), false)}
          step="0.25"
          type={INPUT_TYPE_NUMBER}
          units="sec"
          value={prepareValue(GALLERY_TRANSITION_DURATION)}
        />
      </SplitMergeWrapper>
    </>
  );
};

export default ElementPropertiesGallerySimple;
